const roleKeys = {
  0: 'AUDIT_LOGS.ROLES.AGENT',
  1: 'AUDIT_LOGS.ROLES.ADMINISTRATOR',
};

const availabilityKeys = {
  0: 'AUDIT_LOGS.AVAILABILITY.ONLINE',
  1: 'AUDIT_LOGS.AVAILABILITY.OFFLINE',
  2: 'AUDIT_LOGS.AVAILABILITY.BUSY',
};

const conversationStatusKeys = {
  0: 'open',
  1: 'resolved',
  2: 'pending',
  3: 'snoozed',
};

const conversationPriorityKeys = {
  0: 'low',
  1: 'medium',
  2: 'high',
  3: 'urgent',
};

const translationKeys = {
  'automationrule:create': `AUDIT_LOGS.AUTOMATION_RULE.ADD`,
  'automationrule:update': `AUDIT_LOGS.AUTOMATION_RULE.EDIT`,
  'automationrule:destroy': `AUDIT_LOGS.AUTOMATION_RULE.DELETE`,
  'webhook:create': `AUDIT_LOGS.WEBHOOK.ADD`,
  'webhook:update': `AUDIT_LOGS.WEBHOOK.EDIT`,
  'webhook:destroy': `AUDIT_LOGS.WEBHOOK.DELETE`,
  'inbox:create': `AUDIT_LOGS.INBOX.ADD`,
  'inbox:update': `AUDIT_LOGS.INBOX.EDIT`,
  'inbox:destroy': `AUDIT_LOGS.INBOX.DELETE`,
  'user:sign_in': `AUDIT_LOGS.USER_ACTION.SIGN_IN`,
  'user:sign_out': `AUDIT_LOGS.USER_ACTION.SIGN_OUT`,
  'team:create': `AUDIT_LOGS.TEAM.ADD`,
  'team:update': `AUDIT_LOGS.TEAM.EDIT`,
  'team:destroy': `AUDIT_LOGS.TEAM.DELETE`,
  'macro:create': `AUDIT_LOGS.MACRO.ADD`,
  'macro:update': `AUDIT_LOGS.MACRO.EDIT`,
  'macro:destroy': `AUDIT_LOGS.MACRO.DELETE`,
  'accountuser:create': `AUDIT_LOGS.ACCOUNT_USER.ADD`,
  'accountuser:update:self': `AUDIT_LOGS.ACCOUNT_USER.EDIT.SELF`,
  'accountuser:update:other': `AUDIT_LOGS.ACCOUNT_USER.EDIT.OTHER`,
  'accountuser:update:deleted': `AUDIT_LOGS.ACCOUNT_USER.EDIT.DELETED`,
  'accountuser:destroy': `AUDIT_LOGS.ACCOUNT_USER.DELETE`,
  'inboxmember:create': `AUDIT_LOGS.INBOX_MEMBER.ADD`,
  'inboxmember:destroy': `AUDIT_LOGS.INBOX_MEMBER.REMOVE`,
  'teammember:create': `AUDIT_LOGS.TEAM_MEMBER.ADD`,
  'teammember:destroy': `AUDIT_LOGS.TEAM_MEMBER.REMOVE`,
  'account:update': `AUDIT_LOGS.ACCOUNT.EDIT`,
  'conversation:update': `AUDIT_LOGS.CONVERSATION.EDIT`,
  'conversation:destroy': `AUDIT_LOGS.CONVERSATION.DELETE`,
  'customrole:create': `AUDIT_LOGS.CUSTOM_ROLE.ADD`,
  'customrole:update': `AUDIT_LOGS.CUSTOM_ROLE.EDIT`,
  'customrole:destroy': `AUDIT_LOGS.CUSTOM_ROLE.DELETE`,
  'captain::customtool:create': `AUDIT_LOGS.CUSTOM_TOOL.ADD`,
  'captain::customtool:update': `AUDIT_LOGS.CUSTOM_TOOL.EDIT`,
  'captain::customtool:destroy': `AUDIT_LOGS.CUSTOM_TOOL.DELETE`,
  'agentbot:create': `AUDIT_LOGS.AGENT_BOT.ADD`,
  'agentbot:update': `AUDIT_LOGS.AGENT_BOT.EDIT`,
  'agentbot:destroy': `AUDIT_LOGS.AGENT_BOT.DELETE`,
  'accountsamlsettings:create': `AUDIT_LOGS.SAML_SETTINGS.ADD`,
  'accountsamlsettings:update': `AUDIT_LOGS.SAML_SETTINGS.EDIT`,
  'accountsamlsettings:destroy': `AUDIT_LOGS.SAML_SETTINGS.DELETE`,
  'label:create': `AUDIT_LOGS.LABEL.ADD`,
  'label:update': `AUDIT_LOGS.LABEL.EDIT`,
  'label:destroy': `AUDIT_LOGS.LABEL.DELETE`,
  'cannedresponse:create': `AUDIT_LOGS.CANNED_RESPONSE.ADD`,
  'cannedresponse:update': `AUDIT_LOGS.CANNED_RESPONSE.EDIT`,
  'cannedresponse:destroy': `AUDIT_LOGS.CANNED_RESPONSE.DELETE`,
  'campaign:create': `AUDIT_LOGS.CAMPAIGN.ADD`,
  'campaign:update': `AUDIT_LOGS.CAMPAIGN.EDIT`,
  'campaign:destroy': `AUDIT_LOGS.CAMPAIGN.DELETE`,
  'slapolicy:create': `AUDIT_LOGS.SLA_POLICY.ADD`,
  'slapolicy:update': `AUDIT_LOGS.SLA_POLICY.EDIT`,
  'slapolicy:destroy': `AUDIT_LOGS.SLA_POLICY.DELETE`,
  'customattributedefinition:create': `AUDIT_LOGS.CUSTOM_ATTRIBUTE.ADD`,
  'customattributedefinition:update': `AUDIT_LOGS.CUSTOM_ATTRIBUTE.EDIT`,
  'customattributedefinition:destroy': `AUDIT_LOGS.CUSTOM_ATTRIBUTE.DELETE`,
  'integrations::hook:create': `AUDIT_LOGS.INTEGRATION_HOOK.ADD`,
  'integrations::hook:update': `AUDIT_LOGS.INTEGRATION_HOOK.EDIT`,
  'integrations::hook:destroy': `AUDIT_LOGS.INTEGRATION_HOOK.DELETE`,
  'dashboardapp:create': `AUDIT_LOGS.DASHBOARD_APP.ADD`,
  'dashboardapp:update': `AUDIT_LOGS.DASHBOARD_APP.EDIT`,
  'dashboardapp:destroy': `AUDIT_LOGS.DASHBOARD_APP.DELETE`,
  'contact:destroy': `AUDIT_LOGS.CONTACT.DELETE`,
  'captain::assistantresponse:create': `AUDIT_LOGS.CAPTAIN_FAQ.ADD`,
  'captain::assistantresponse:update': `AUDIT_LOGS.CAPTAIN_FAQ.EDIT`,
  'captain::assistantresponse:destroy': `AUDIT_LOGS.CAPTAIN_FAQ.DELETE`,
  'captain::document:create': `AUDIT_LOGS.CAPTAIN_DOCUMENT.ADD`,
  'captain::document:update': `AUDIT_LOGS.CAPTAIN_DOCUMENT.EDIT`,
  'captain::document:destroy': `AUDIT_LOGS.CAPTAIN_DOCUMENT.DELETE`,
  'captain::scenario:create': `AUDIT_LOGS.CAPTAIN_SCENARIO.ADD`,
  'captain::scenario:update': `AUDIT_LOGS.CAPTAIN_SCENARIO.EDIT`,
  'captain::scenario:destroy': `AUDIT_LOGS.CAPTAIN_SCENARIO.DELETE`,
  'captain::assistant:create': `AUDIT_LOGS.CAPTAIN_ASSISTANT.ADD`,
  'captain::assistant:update': `AUDIT_LOGS.CAPTAIN_ASSISTANT.EDIT`,
  'captain::assistant:destroy': `AUDIT_LOGS.CAPTAIN_ASSISTANT.DELETE`,
  'captain::inbox:create': `AUDIT_LOGS.CAPTAIN_INBOX.ADD`,
  'captain::inbox:destroy': `AUDIT_LOGS.CAPTAIN_INBOX.DELETE`,
  'call:outbound': `AUDIT_LOGS.CALL.OUTBOUND`,
  'call:inbound': `AUDIT_LOGS.CALL.INBOUND`,
  'dataimport:complete': `AUDIT_LOGS.DATA_IMPORT.COMPLETE`,
  'account:export': `AUDIT_LOGS.CONTACTS_EXPORT.COMPLETE`,
  'portal:create': `AUDIT_LOGS.PORTAL.ADD`,
  'portal:update': `AUDIT_LOGS.PORTAL.EDIT`,
  'portal:destroy': `AUDIT_LOGS.PORTAL.DELETE`,
  'category:create': `AUDIT_LOGS.CATEGORY.ADD`,
  'category:update': `AUDIT_LOGS.CATEGORY.EDIT`,
  'category:destroy': `AUDIT_LOGS.CATEGORY.DELETE`,
  'article:create': `AUDIT_LOGS.ARTICLE.ADD`,
  'article:update': `AUDIT_LOGS.ARTICLE.EDIT`,
  'article:destroy': `AUDIT_LOGS.ARTICLE.DELETE`,
  'company:create': `AUDIT_LOGS.COMPANY.ADD`,
  'company:update': `AUDIT_LOGS.COMPANY.EDIT`,
  'company:destroy': `AUDIT_LOGS.COMPANY.DELETE`,
};

const SKIP_FIELDS = new Set([
  'account_id',
  'certificate',
  'id',
  'created_at',
  'updated_at',
  'display_name',
  'inbox_name',
  'team_name',
  'assistant_name',
  'contact_id',
  'contact_name',
  'count',
]);

const FIELD_LABEL_KEYS = {
  sso_url: 'AUDIT_LOGS.SAML_SETTINGS.ATTRIBUTES.SSO_URL',
  idp_entity_id: 'AUDIT_LOGS.SAML_SETTINGS.ATTRIBUTES.IDP_ENTITY_ID',
  sp_entity_id: 'AUDIT_LOGS.SAML_SETTINGS.ATTRIBUTES.SP_ENTITY_ID',
  role_mappings: 'AUDIT_LOGS.SAML_SETTINGS.ATTRIBUTES.ROLE_MAPPINGS',
  assignee_id: 'AUDIT_LOGS.ATTRIBUTES.ASSIGNEE',
  status: 'AUDIT_LOGS.ATTRIBUTES.STATUS',
  priority: 'AUDIT_LOGS.ATTRIBUTES.PRIORITY',
  team_id: 'AUDIT_LOGS.ATTRIBUTES.TEAM',
  title: 'AUDIT_LOGS.ATTRIBUTES.TITLE',
  name: 'AUDIT_LOGS.ATTRIBUTES.NAME',
  short_code: 'AUDIT_LOGS.ATTRIBUTES.SHORT_CODE',
  content: 'AUDIT_LOGS.ATTRIBUTES.CONTENT',
  color: 'AUDIT_LOGS.ATTRIBUTES.COLOR',
  description: 'AUDIT_LOGS.ATTRIBUTES.DESCRIPTION',
  cached_label_list: 'AUDIT_LOGS.ATTRIBUTES.LABELS',
  question: 'AUDIT_LOGS.ATTRIBUTES.QUESTION',
  settings: 'AUDIT_LOGS.ATTRIBUTES.SETTINGS',
};

const SAML_FIELD_ORDER = [
  'sso_url',
  'idp_entity_id',
  'sp_entity_id',
  'role_mappings',
];

const SPECIAL_AUDIT_TYPES = new Set([
  'accountuser',
  'inboxmember',
  'teammember',
  'user',
]);

function extractAttrChange(attrChange) {
  if (Array.isArray(attrChange)) {
    return attrChange[attrChange.length - 1];
  }
  return attrChange;
}

function hasAuditedChange(value) {
  return (
    value !== undefined &&
    value !== null &&
    !(Array.isArray(value) && !value.length)
  );
}

function customRoleDisplayName(customRoleId, customRoles, t) {
  if (customRoleId == null) {
    return t('AUDIT_LOGS.ACCOUNT_USER.NO_CUSTOM_ROLE');
  }

  const customRole = customRoles.find(
    role => Number(role.id) === Number(customRoleId)
  );
  return customRole?.name || String(customRoleId);
}

export function extractChangedAccountUserValues(
  auditedChanges,
  t,
  customRoles = []
) {
  let changes = [];
  let values = [];

  // Check roles
  if (auditedChanges.role && auditedChanges.role.length) {
    changes.push('role');
    const roleKey =
      roleKeys[extractAttrChange(auditedChanges.role)] ||
      'AUDIT_LOGS.ROLES.UNKNOWN';
    values.push(t(roleKey));
  }

  // Check availability
  if (auditedChanges.availability && auditedChanges.availability.length) {
    changes.push('availability');
    const availabilityKey =
      availabilityKeys[extractAttrChange(auditedChanges.availability)] ||
      'AUDIT_LOGS.ROLES.UNKNOWN';
    values.push(t(availabilityKey));
  }

  if (hasAuditedChange(auditedChanges.custom_role_id)) {
    changes.push(t('AUDIT_LOGS.ACCOUNT_USER.CUSTOM_ROLE_ATTRIBUTE'));
    const customRoleId = extractAttrChange(auditedChanges.custom_role_id);
    values.push(customRoleDisplayName(customRoleId, customRoles, t));
  }

  return { changes, values };
}

function getAgentName(userId, agentList, t) {
  if (userId === null || userId === undefined) {
    return t('AUDIT_LOGS.DEFAULT_USER');
  }

  const agentName = agentList.find(agent => agent.id === userId)?.name;

  // If agent does not exist(removed/deleted), return userId
  return agentName || userId;
}

function parseJsonObjectOrArray(value) {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed === 'object') {
      return parsed;
    }
  } catch {
    return undefined;
  }

  return undefined;
}

function collectLeafValues(value, t) {
  if (value === '[FILTERED]') {
    return [t('AUDIT_LOGS.FILTERED')];
  }
  if (value === undefined || value === null || value === '') {
    return [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(item => collectLeafValues(item, t));
  }

  const parsedJson = parseJsonObjectOrArray(value);
  if (parsedJson !== undefined) {
    return collectLeafValues(parsedJson, t);
  }

  if (typeof value === 'object') {
    return Object.values(value).flatMap(item => collectLeafValues(item, t));
  }

  return [String(value)];
}

function formatScalarValue(value, t) {
  if (value === '[FILTERED]') {
    return t('AUDIT_LOGS.FILTERED');
  }
  if (value === undefined || value === null || value === '') {
    return t('AUDIT_LOGS.EMPTY');
  }
  if (
    typeof value === 'object' ||
    parseJsonObjectOrArray(value) !== undefined
  ) {
    const leaves = collectLeafValues(value, t);
    if (!leaves.length) {
      return t('AUDIT_LOGS.EMPTY');
    }
    return leaves.join(', ');
  }
  return String(value);
}

function formatEntityRef(id, name) {
  if (id === null || id === undefined || id === '') {
    return id;
  }
  const label = name == null ? '' : String(name).trim();
  return label ? `${id} ${label}` : id;
}

function extractEntityName(changes = {}) {
  return (
    changes.display_name ||
    extractAttrChange(changes.name) ||
    extractAttrChange(changes.title) ||
    extractAttrChange(changes.question) ||
    extractAttrChange(changes.short_code) ||
    extractAttrChange(changes.assistant_name) ||
    ''
  );
}

function formatEnumValue(value, mapping, prefix, t) {
  const mapped = mapping[value] || value;
  if (mapped == null || mapped === '') {
    return t('AUDIT_LOGS.EMPTY');
  }
  return t(`${prefix}.${String(mapped).toUpperCase()}`);
}

function formatFieldValue(key, value, t, options = {}) {
  if (value === '[FILTERED]') {
    return t('AUDIT_LOGS.FILTERED');
  }

  if (options.auditableType === 'conversation' && key === 'status') {
    return formatEnumValue(
      value,
      conversationStatusKeys,
      'AUDIT_LOGS.CONVERSATION.STATUS',
      t
    );
  }

  if (options.auditableType === 'conversation' && key === 'priority') {
    return formatEnumValue(
      value,
      conversationPriorityKeys,
      'AUDIT_LOGS.CONVERSATION.PRIORITY',
      t
    );
  }

  if (key === 'assignee_id') {
    if (value === null || value === undefined || value === '') {
      return t('AUDIT_LOGS.CONVERSATION.UNASSIGNED');
    }
    return String(getAgentName(value, options.agentList || [], t));
  }

  if (key === 'team_id') {
    if (value === null || value === undefined || value === '') {
      return t('AUDIT_LOGS.EMPTY');
    }
    return formatEntityRef(value, options.teamName);
  }

  if (key === 'inbox_id') {
    if (value === null || value === undefined || value === '') {
      return t('AUDIT_LOGS.EMPTY');
    }
    return formatEntityRef(value, options.inboxName);
  }

  return formatScalarValue(value, t);
}

function formatChangeValue(key, attrChange, t, options = {}) {
  if (Array.isArray(attrChange) && attrChange.length === 2) {
    const previousOptions = {
      ...options,
      teamName: undefined,
      inboxName: undefined,
    };
    return `${formatFieldValue(key, attrChange[0], t, previousOptions)} → ${formatFieldValue(key, attrChange[1], t, options)}`;
  }
  return formatFieldValue(key, extractAttrChange(attrChange), t, options);
}

function fieldLabel(key, t, fieldLabelKeys) {
  const labelKey = fieldLabelKeys[key] || FIELD_LABEL_KEYS[key];
  return labelKey ? t(labelKey) : key.replace(/_/g, ' ');
}

export function extractChangedFieldValues(auditedChanges, t, options = {}) {
  const changes = [];
  const values = [];
  const skipFields = options.skipFields || SKIP_FIELDS;
  const fieldLabelKeys = options.fieldLabelKeys || FIELD_LABEL_KEYS;
  const keys = Object.keys(auditedChanges || {}).filter(
    key => !skipFields.has(key)
  );
  const fieldOrder = options.fieldOrder || [];
  const orderedKeys = [
    ...fieldOrder.filter(key => keys.includes(key)),
    ...keys.filter(key => !fieldOrder.includes(key)),
  ];

  orderedKeys.forEach(key => {
    if (!hasAuditedChange(auditedChanges[key])) {
      return;
    }
    changes.push(fieldLabel(key, t, fieldLabelKeys));
    values.push(formatChangeValue(key, auditedChanges[key], t, options));
  });

  return { changes, values };
}

export function extractChangedSamlSettingsValues(auditedChanges, t) {
  return extractChangedFieldValues(auditedChanges, t, {
    skipFields: SKIP_FIELDS,
    fieldLabelKeys: FIELD_LABEL_KEYS,
    fieldOrder: SAML_FIELD_ORDER,
  });
}

function handleAccountUserCreate(
  auditLogItem,
  translationPayload,
  agentList,
  t
) {
  translationPayload.invitee = getAgentName(
    auditLogItem.audited_changes.user_id,
    agentList,
    t
  );

  const roleKey = auditLogItem.audited_changes.role;
  translationPayload.role = t(roleKeys[roleKey] || 'AUDIT_LOGS.ROLES.UNKNOWN');

  return translationPayload;
}

function handleAccountUserUpdate(
  auditLogItem,
  translationPayload,
  agentList,
  t,
  customRoles
) {
  if (auditLogItem.user_id !== auditLogItem.auditable?.user_id) {
    translationPayload.user = getAgentName(
      auditLogItem.auditable?.user_id,
      agentList,
      t
    );
  }

  const accountUserChanges = extractChangedAccountUserValues(
    auditLogItem.audited_changes,
    t,
    customRoles
  );
  if (accountUserChanges) {
    translationPayload.attributes = accountUserChanges.changes;
    translationPayload.values = accountUserChanges.values;
  }
  return translationPayload;
}

function handleAccountUserDestroy(
  auditLogItem,
  translationPayload,
  agentList,
  t
) {
  translationPayload.invitee = getAgentName(
    extractAttrChange(auditLogItem.audited_changes?.user_id),
    agentList,
    t
  );
  return translationPayload;
}

function setUserInPayload(auditLogItem, translationPayload, agentList, t) {
  const userIdChange = auditLogItem.audited_changes.user_id;
  if (userIdChange && userIdChange !== undefined) {
    translationPayload.user = getAgentName(userIdChange, agentList, t);
  }
  return translationPayload;
}

function setTeamIdInPayload(auditLogItem, translationPayload) {
  const changes = auditLogItem.audited_changes || {};
  if (hasAuditedChange(changes.team_id)) {
    translationPayload.team_id = formatEntityRef(
      extractAttrChange(changes.team_id),
      changes.team_name
    );
  }
  return translationPayload;
}

function setInboxIdInPayload(auditLogItem, translationPayload) {
  const changes = auditLogItem.audited_changes || {};
  if (hasAuditedChange(changes.inbox_id)) {
    translationPayload.inbox_id = formatEntityRef(
      extractAttrChange(changes.inbox_id),
      changes.inbox_name
    );
  }
  return translationPayload;
}

function handleInboxTeamMember(auditLogItem, translationPayload, agentList, t) {
  if (auditLogItem.audited_changes) {
    translationPayload = setUserInPayload(
      auditLogItem,
      translationPayload,
      agentList,
      t
    );
    translationPayload = setTeamIdInPayload(auditLogItem, translationPayload);
    translationPayload = setInboxIdInPayload(auditLogItem, translationPayload);
  }
  return translationPayload;
}

function handleAccountUser(
  auditLogItem,
  translationPayload,
  agentList,
  action,
  t,
  customRoles
) {
  if (action === 'create') {
    return handleAccountUserCreate(
      auditLogItem,
      translationPayload,
      agentList,
      t
    );
  }

  if (action === 'update') {
    return handleAccountUserUpdate(
      auditLogItem,
      translationPayload,
      agentList,
      t,
      customRoles
    );
  }

  if (action === 'destroy') {
    return handleAccountUserDestroy(
      auditLogItem,
      translationPayload,
      agentList,
      t
    );
  }

  return translationPayload;
}

function applyFieldDiffs(auditLogItem, translationPayload, agentList, t) {
  const auditableType = auditLogItem.auditable_type.toLowerCase();
  const changes = auditLogItem.audited_changes || {};
  const skipFields = new Set(SKIP_FIELDS);
  if (auditableType === 'conversation') {
    skipFields.add('display_id');
    skipFields.add('inbox_id');
  }

  const fieldChanges = extractChangedFieldValues(changes, t, {
    agentList,
    auditableType,
    skipFields,
    teamName: changes.team_name,
    inboxName: changes.inbox_name,
    fieldOrder: auditableType === 'accountsamlsettings' ? SAML_FIELD_ORDER : [],
  });
  translationPayload.attributes = fieldChanges.changes;
  translationPayload.values = fieldChanges.values;
  return translationPayload;
}

export function generateTranslationPayload(
  auditLogItem,
  agentList,
  t,
  customRoles = []
) {
  const changes = auditLogItem.audited_changes || {};
  const auditableType = auditLogItem.auditable_type.toLowerCase();
  const action = auditLogItem.action.toLowerCase();
  const entityId =
    auditableType === 'conversation'
      ? changes.display_id || auditLogItem.auditable_id
      : auditLogItem.auditable_id;

  let translationPayload = {
    agentName: getAgentName(auditLogItem.user_id, agentList, t),
    id: formatEntityRef(entityId, extractEntityName(changes)),
    type: auditLogItem.auditable_type,
    action: auditLogItem.action,
  };

  if (auditableType === 'accountuser') {
    translationPayload = handleAccountUser(
      auditLogItem,
      translationPayload,
      agentList,
      action,
      t,
      customRoles
    );
  } else if (
    auditableType === 'inboxmember' ||
    auditableType === 'teammember'
  ) {
    translationPayload = handleInboxTeamMember(
      auditLogItem,
      translationPayload,
      agentList,
      t
    );
  } else if (auditableType === 'call') {
    translationPayload.contact = formatEntityRef(
      changes.contact_id,
      changes.contact_name
    );
  } else if (auditableType === 'dataimport' || action === 'export') {
    translationPayload.count =
      changes.count ?? changes.processed_records ?? changes.total_records ?? 0;
  } else if (auditableType === 'captain::inbox') {
    translationPayload.inbox = formatEntityRef(
      changes.inbox_id,
      changes.inbox_name
    );
  } else if (!SPECIAL_AUDIT_TYPES.has(auditableType) && action !== 'destroy') {
    translationPayload = applyFieldDiffs(
      auditLogItem,
      translationPayload,
      agentList,
      t
    );
  }

  return translationPayload;
}

function getAccountUserUpdateSuffix(auditLogItem) {
  if (auditLogItem.auditable === null) {
    // If the user is deleted, we don't need to check if the user is the same as the auditLogItem.user_id
    // Else we can use the deleted translation key
    // It doesn't need the agent name
    return ':deleted';
  }
  return auditLogItem.user_id === auditLogItem.auditable.user_id
    ? ':self'
    : ':other';
}

export const generateLogActionKey = auditLogItem => {
  const auditableType = auditLogItem.auditable_type.toLowerCase();
  const action = auditLogItem.action.toLowerCase();
  let logActionKey = `${auditableType}:${action}`;

  if (auditableType === 'accountuser' && action === 'update') {
    logActionKey += getAccountUserUpdateSuffix(auditLogItem);
  }

  return translationKeys[logActionKey] || 'AUDIT_LOGS.UNKNOWN_ACTIVITY';
};
